export const limpiarNumero = (num) => {

    let num1 = num.replace(' ', '');
    let num2 = num1.replace('-', '');

    return num2;


}